import { ListRenderItem } from '@shopify/flash-list';
import { PageFlatList } from 'components/Page';
import { Txt } from 'components/Txt';
import { useSelector } from 'hooks/useSelector';
import { theme } from 'lib/theme';
import * as React from 'react';
import { StyleSheet, View } from 'react-native';
import { ListItem } from 'screens/AssetsScreen/LocalAssets/ListItem';
import {
  selectAssetsTotal,
  selectFilteredAssetsListIds,
  selectFilteredAssetsListTotal,
} from 'store/assets/selectors';

import { LocalAssetsHeader } from './LocalAssetsHeader';

const renderItem: ListRenderItem<string> = ({ item }) => <ListItem id={item} />;

export const LocalAssets: React.FC = () => {
  const assetIds = useSelector(selectFilteredAssetsListIds);
  const allAssetsTotal = useSelector(selectAssetsTotal);
  const currentAssetsTotal = useSelector(selectFilteredAssetsListTotal);
  const filterMessage =
    currentAssetsTotal !== allAssetsTotal
      ? `${currentAssetsTotal} of ${allAssetsTotal} Assets Shown`
      : null;

  return (
    <PageFlatList
      isInModal={false}
      header={<LocalAssetsHeader />}
      backgroundColor="white"
      listConfig={{
        data: assetIds,
        keyExtractor: (item) => item,
        ListFooterComponent: filterMessage ? (
          <View style={styles.footerContainer}>
            <Txt>{filterMessage}</Txt>
          </View>
        ) : undefined,
        renderItem,
      }}
    />
  );
};

const styles = StyleSheet.create({
  footerContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: theme.grid * 2,
  },
});
